import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../core/providers/AuthProvider';
import { NavigationProvider } from './NavigationProvider';
import AuthModals from './AuthModals';
import DashboardLayout from '../shared/layouts/DashboardLayout';
import AuthHome from '../features/auth/components/AuthHome';
import { HomePage } from '../features/home';
import { LlmDashboard } from '../features/llm';

import { NotificationsPage } from '../features/notifications';
import { ProfilePage } from '../features/profile';
import { ActivityDetailsPage, MyActivitiesPage } from '../features/activities';
import PublicActivityPage from '../features/activities/pages/PublicActivityPage';
import { WizardPage } from '../features/wizard';
import { ROUTES } from '../core/constants/routes';
import SettingsPage from '../features/settings/pages/SettingsPage';
import ToolsTestPage from '../features/dev/pages/ToolsTestPage';
import IntentTestPage from '../features/dev/pages/IntentTestPage';

const AppRoutes = () => {
  const { loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <NavigationProvider>
      <Routes>
        <Route path={ROUTES.HOME} element={<AuthHome />} />
        <Route path={ROUTES.DASHBOARD} element={<DashboardLayout />}>
          {/* Redirect /dashboard to /dashboard/llm */}
          <Route index element={<Navigate to="llm" replace />} />
          <Route path="llm" element={<LlmDashboard />} />
          <Route path="feed" element={<HomePage />} />
          <Route path="my-activities" element={<MyActivitiesPage />} />

          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="profile/:uid" element={<ProfilePage />} />
          <Route path="activity/:id" element={<ActivityDetailsPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
        {/* Route publique /activity/:id - accessible sans auth (GPT Store - RAS-41) */}
        <Route path={`${ROUTES.PUBLIC_ACTIVITY}/:id`} element={<PublicActivityPage />} />
        {/* Dev routes - only in development, outside auth */}
        {process.env.NODE_ENV !== 'production' && (
          <>
            <Route path="/dev/tools" element={<ToolsTestPage />} />
            <Route path="/dev/intent" element={<IntentTestPage />} />
          </>
        )}
        <Route path={ROUTES.WIZARD} element={<WizardPage />} />
      </Routes>
      <AuthModals />
    </NavigationProvider>
  );
};

export default AppRoutes; 